import { useQuery } from '@tanstack/react-query';
import { supabase } from '../config/supabase';
import { telemetryService } from '../services/telemetry/telemetryService';

export type StrokeStabilityRecord = {
  stroke_timestamp: number;
  stroke_idx: number;
  stability_index: number | null;
  clean_for_analysis: boolean;
  instability_score: number | null;
  roll_at_stroke: number | null;
  pre_catch_abs_roll_mean: number | null;
  drive_roll_std: number | null;
};

export function useStrokeStabilityData(sessionId: string | null) {
  return useQuery({
    queryKey: ['session', 'stroke-stability', sessionId],
    enabled: !!sessionId,
    staleTime: 30_000,
    refetchOnMount: true,
    queryFn: async (): Promise<StrokeStabilityRecord[]> => {
      if (!sessionId) return [];
      const resolvedId = await telemetryService.resolveSessionId(sessionId);
      if (!resolvedId) return [];

      const { data, error } = await supabase
        .from('telemetry_stroke_stability')
        .select(
          'stroke_timestamp, stroke_idx, stability_index, clean_for_analysis, instability_score, roll_at_stroke, pre_catch_abs_roll_mean, drive_roll_std'
        )
        .eq('session_id', resolvedId)
        .order('stroke_timestamp', { ascending: true });

      if (error) throw error;
      return (data ?? []) as StrokeStabilityRecord[];
    },
  });
}
